import React, { useEffect, useRef } from 'react';
import { fireConfetti } from '../lib/fireConfetti';
import { Canvas } from './WinnerConfetti.styles';

export interface WinnerConfettiProps {
  /** true 가 되면 1회 confetti 재생 */
  active: boolean;
  /** confetti 시작점 — 우승 카드 등 */
  originRef?: React.RefObject<HTMLElement | null>;
}

function getOriginFromElement(
  host: HTMLElement,
  originEl: HTMLElement,
): { originX: number; originY: number } {
  const hostRect = host.getBoundingClientRect();
  const cardRect = originEl.getBoundingClientRect();

  return {
    originX: cardRect.left - hostRect.left + cardRect.width / 2,
    originY: cardRect.top - hostRect.top + cardRect.height * 0.38,
  };
}

/**
 * 1위 공개 시 우승 카드 위치에서 confetti 버스트 (canvas).
 */
export function WinnerConfetti({ active, originRef }: WinnerConfettiProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const firedRef = useRef(false);

  useEffect(() => {
    if (!active || firedRef.current) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const canvas = canvasRef.current;
    const host = canvas?.parentElement;
    if (!canvas || !host) {
      return;
    }

    firedRef.current = true;
    let cleanup: () => void = () => {};

    const frameId = window.requestAnimationFrame(() => {
      const { width, height } = host.getBoundingClientRect();
      const originEl = originRef?.current;
      const origin = originEl
        ? getOriginFromElement(host, originEl)
        : { originX: width * 0.5, originY: height * 0.43 };

      cleanup = fireConfetti(canvas, {
        width,
        height,
        originX: origin.originX,
        originY: origin.originY,
        radial: true,
        particleCount: 88,
      });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
      cleanup();
    };
  }, [active, originRef]);

  return <Canvas ref={canvasRef} aria-hidden="true" />;
}
